export default function Services() {
  const services = [
    {
      title: '遺品整理',
      description: '故人様の大切な遺品を、ご遺族の気持ちに寄り添いながら丁寧に整理いたします。思い出の品の仕分けから不用品の処分まで、心を込めて対応させていただきます。',
      icon: 'ri-home-heart-line',
      image: 'https://public.readdy.ai/ai/img_res/2ca75eb844db61eee2d5e9a3cb9ad037.jpg'
    },
    {
      title: '生前整理',
      description: 'ご自身やご家族の将来に備えて、大切なものを整理するお手伝いをいたします。必要なものと不要なものを一緒に考えながら、快適な生活空間を作ります。',
      icon: 'ri-user-heart-line',
      image: 'https://readdy.ai/api/search-image?query=Senior-friendly%20decluttering%20and%20life%20organization%20service%20showing%20a%20peaceful%20elderly%20person%20with%20professional%20organizer%20in%20a%20bright%2C%20clean%20Japanese%20room%2C%20carefully%20sorting%20through%20belongings%2C%20warm%20and%20reassuring%20atmosphere%2C%20simple%20background%2C%20emphasizing%20comfort%20and%20trust&width=600&height=400&seq=service-2&orientation=landscape'
    },
    {
      title: '不用品回収',
      description: '家具・家電・日用品など、あらゆる不用品を迅速に回収いたします。大型家具の搬出も安心してお任せください。リサイクル可能なものは適切に処理いたします。',
      icon: 'ri-recycle-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20junk%20removal%20and%20recycling%20service%20with%20workers%20carefully%20loading%20furniture%20and%20household%20items%20into%20a%20clean%20truck%2C%20organized%20and%20efficient%20work%2C%20bright%20daylight%2C%20simple%20background%2C%20showing%20responsible%20disposal%20and%20environmental%20care&width=600&height=400&seq=service-3&orientation=landscape'
    },
    {
      title: '特殊清掃',
      description: '通常の清掃では対応が難しい現場も、専門の技術と機材で徹底的に清掃いたします。プライバシーに配慮し、近隣への配慮も万全です。',
      icon: 'ri-brush-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20deep%20cleaning%20and%20sanitization%20service%20in%20a%20Japanese%20home%2C%20showing%20workers%20in%20protective%20gear%20using%20specialized%20equipment%2C%20spotless%20results%2C%20bright%20and%20clean%20atmosphere%2C%20simple%20background%2C%20emphasizing%20thoroughness%20and%20professionalism&width=600&height=400&seq=service-4&orientation=landscape'
    },
    {
      title: 'ゴミ屋敷片付け',
      description: 'どのような状態のお部屋でも、判断せず誠実に対応いたします。秘密厳守で、近隣に配慮しながら迅速に作業を進めます。新しい生活のスタートを応援します。',
      icon: 'ri-delete-bin-line',
      image: 'https://readdy.ai/api/search-image?query=Compassionate%20hoarding%20cleanup%20service%20showing%20dramatic%20before%20and%20after%20transformation%20of%20a%20cluttered%20room%20into%20a%20clean%20organized%20space%2C%20professional%20workers%2C%20respectful%20approach%2C%20simple%20background%2C%20emphasizing%20hope%20and%20fresh%20start&width=600&height=400&seq=service-5&orientation=landscape'
    },
    {
      title: 'ご供養サービス',
      description: '提携寺院と連携し、お焚き上げや合同供養を承ります。故人様の思い出の品を、心を込めてご供養させていただきます。',
      icon: 'ri-hand-heart-line',
      image: 'https://readdy.ai/api/search-image?query=Respectful%20memorial%20and%20offering%20service%20at%20a%20serene%20Japanese%20temple%2C%20showing%20traditional%20Buddhist%20ceremony%20with%20incense%20and%20prayers%2C%20peaceful%20atmosphere%2C%20soft%20lighting%2C%20simple%20background%2C%20conveying%20spiritual%20care%20and%20reverence%20for%20cherished%20belongings&width=600&height=400&seq=service-6&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">サービス内容</h2>
          <p className="text-lg text-gray-600">
            遺品整理から生前整理まで、幅広いサービスでお客様をサポートいたします
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-green-100 rounded-full p-3">
                    <i className={`${service.icon} text-3xl text-green-600 w-8 h-8 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
